import { FileText, Phone } from "lucide-react";
import { BUSINESS } from "@/lib/content";
import { goToEstimate } from "@/lib/scroll";

export const MobileBar = () => (
  <div data-testid="mobile-action-bar" className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-white/10 bg-[#0B0F17]/90 p-3 backdrop-blur-xl md:hidden">
    <a href={BUSINESS.phoneHref} data-testid="mobile-call-btn" className="ks-btn-ghost justify-center py-3"><Phone className="h-4 w-4" /> Call</a>
    <button onClick={() => goToEstimate()} data-testid="mobile-quote-btn" className="ks-btn-gold justify-center py-3"><FileText className="h-4 w-4" /> Get a Quote</button>
  </div>
);
